import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=e1cb30ec&scoped=true"
import script from "./PortalFooter.vue?vue&type=script&lang=js"
export * from "./PortalFooter.vue?vue&type=script&lang=js"
import style0 from "./PortalFooter.vue?vue&type=style&index=0&id=e1cb30ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cb30ec",
  null
  
)

export default component.exports